import {Component} from 'preact';
import { putQrCodeBouncer } from '../services/QRCodeConfigurationService'
import {route} from "preact-router";

require('../styles/Home.scss')

export class Home extends Component {
    state = {
        url: '',
        anErrorOccurred: false,
        withoutUrlPrefix: false
    }
    constructor() {
        super();
    }

    activateUrl = async (accountId, id, url) => {
        const pattern = /^((http|https):\/\/)/;
        const isvalid = pattern.test(this.state.url)
        this.setState({withoutUrlPrefix: !isvalid})
        if (isvalid) {
            const result = await putQrCodeBouncer(accountId, id, url);
            switch (result.status) {
                case 200:
                    route('/success')
                    break
                default:
                    this.setState({ anErrorOccurred: true })
            }
        }

    }

    componentDidUpdate( prevProps, prevState) {
        if (prevState.url !== this.state.url) {
            this.setState({anErrorOccurred: false})
            this.setState({withoutUrlPrefix: false})
        }
    }

    render(props, state) {
        return <div className='container'>
            <div className='header'>
                <div className='header-title'>
                </div>
            </div>
            <div className='divider-100'/>
            <div className='content-container'>
                <div className='input-container'>
                    <label>
                        Coller l’URL* qui sera liée à votre QR code :
                    </label>
                    <input className='full-input-mobile' placeholder={'URL'}
                           onInput={(event) => {
                               this.setState({url: event.target.value})
                           }}/>
                    {this.state.anErrorOccurred && <div className='error'>Une erreur s’est produite.</div>}
                    {this.state.withoutUrlPrefix && <div className='error'>Un URL doit commencer par <b>http://</b> ou <b>https://</b></div>}
                </div>
                <div className='divider-33'/>
                <div className='center'>
                    <button className='button center' onClick={() => this.activateUrl(props.accountId ,props.id, this.state.url)}>
                        Activer mon QR code
                    </button>
                </div>
                <div className='divider-23'/>
                <div className='center text-center'>
                    <img src='../assets/images/incident-illustration-working-fix.png' height='175'/>
                </div>
                <div className='divider-24'/>
                <div className='info'>
                    <span>Vous trouverez l’URL de votre page de réservation dans votre app Booksy Biz : </span>
                    <a href='/'>
                        Profil (îcone maison en bas à droite) > Configuration > Détail entreprise > Fiche de
                        l’établissement
                    </a>
                </div>
            </div>
        </div>;
    }
}
